<template>
    <div class="container py-3">

        <div class="row">
            <div class="col-lg-3 col-md-5 col-sm-12">
                <NavBarCurse :curseParent="curseId"/>
            </div>
            <div class="col-lg-9 col-md-7 col-sm-12 mt-3 pt-4">
                <router-view></router-view>
            </div>
        </div>

    </div>
</template>
<script>
  import NavBarCurse from './components/NavBarCurse'

  export default {
    components: {
      'NavBarCurse': NavBarCurse
    },
    data() {
      return {
        curseId: {}
      }
    },
    methods: {
      setNavBarCurse(curse) {
        this.curse.id = curse.id
        this.curse.cover = curse.cover
        this.curse.title = curse.title
        this.curse.description = curse.description
      },
      loadCurseFromId(id) {
        this.api.get('course/find/' + id).then(({data}) => {
          if (data.data) {
            this.curseId = data.data
          }
        }).catch(err => {
          console.log(err)
        })
      },
    },
    created() {
      let id = this.$route.params.id
      if (id != undefined) {
        this.loadCurseFromId(id)
      }
    },
    watch: {
      curseId: function (val) {
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/#pages/curses/Generate.vue